module.exports = __webpack_public_path__ + "static/img/2_7_1.724321e1.jpg";